import React from "react";
import styled from "styled-components";
import { ColDiv, RowDiv } from "../components/Layout";
import { H3 } from "../components/Typography";

interface Props {}

const Header: React.FC<Props> = () => {
  return (
    <Background>
      <ColDiv>
        <H3>Alexander</H3>
        <H3>Shorokov</H3>
      </ColDiv>
      <NavItem>
        <H3>Watches</H3>
      </NavItem>
      <NavItem>
        <H3>About Us</H3>
      </NavItem>
      <NavItem>
        <H3>Shopping Cart</H3>
      </NavItem>
    </Background>
  );
};

const Background = styled(RowDiv)`
  display: flex;
  justify-content: space-between;
  padding: 20px;
`;

const NavItem = styled.div``;

export default Header;
